const component = "program";

export const programEditor = {
  identityCard: `${component}/identity-card`,
  identityIcon: `${component}/identity-icon`,
  identityNameLabel: `${component}/identity-name-label`,
  identityNameInput: `${component}/identity-name-input`,
  identityNameError: `${component}/identity-name-error`,
  identityNameText: `${component}/identity-name-text`,
  identitySubtitle: `${component}/identity-subtitle`,
  applianceStep: `${component}/appliance-step`,
  applianceStatus: `${component}/appliance-status`,
  quickConfiguration: `${component}/quick-configuration`,
  quickConfigurationIcon: `${component}/quick-configuration-icon`,
  cancelButton: `${component}/cancel-button`,
  primaryActionButton: `${component}/primary-action-button`,
  editProgramButton: `${component}/edit-button`,
  programColorCard: {
    card: `${component}/program-color-card`,
    title: `${component}/program-color-card/title`,
    colorButton: `${component}/program-color-card/color-button`,
  },
};
